module.exports = __webpack_public_path__ + "img/3.b46edf38.jpeg";